module.exports = __webpack_public_path__ + "img/budget.f1f8f2c6.png";